import React, { useContext, useEffect, useState } from 'react'

import './Courses.css'
import api from '../../Utils/Api'
import { CurrentUserContext } from '../../Contexts/CurrentUserContext'
import OpenedBlock from '../App/Common/BlocksWithCards/OpenedBlock/OpenedBlock'
import LockedTaskCard from '../App/Common/Cards/LockedTaskCard/LockedTaskCard'
import TaskCard from '../App/Common/Cards/TaskCard/TaskCard'
import CourseCard from '../App/Common/Cards/CourseCard/CourseCard'
import { Link } from 'react-router-dom'
import Calendar from '../Calendar/Calendar'
import Archive from './Archive'

const Courses = ({ courses }) => {
  const [tab, setTab] = useState(false)
  const [titleTag, setTitle] = useState('_courses')
  const [coursesProgress, setCoursesProgress] = useState([])
  const cardType = 'course'
  const title = ''
  const { token } = useContext(CurrentUserContext)
  const [performanceData, setPerformanceData] = useState([])

  // useEffect(() => {
  //   courses.forEach((e) => {
  //     api.getProgressCourse(token, e.id).then((res) => {
  //       setCoursesProgress(res)
  //     }).catch((e) => {
  //       console.log(e);
  //     });
  //   })

  // }, [])
  const getTime = (date) => {
    // console.log(performanceData)
    const fullDate = new Date(date)
    const h = fullDate.getHours()
    const m = fullDate.getMinutes()
    //console.log(h, m);
    return `${h.toString().padStart(2, '0')} : ${m.toString().padStart(2, '0')}`
  }
  const getDate = (date) => {
    let newDate = new Date(date)
    // console.log(newDate)
    const d = newDate.getDate()
    const m = newDate.getMonth()
    const y = newDate.getFullYear()
    return `${d.toString().padStart(2, '0')}.${(m + 1)
      .toString()
      .padStart(2, '0')}`
  }
  // console.log(courses)
  useEffect(() => {
    Promise.all([api.getPerformance(token)])
      .then(([performance]) => {
        setPerformanceData(performance)
      })
      .catch((e) => {
        console.log(e)
      })
  }, [])
  console.log(performanceData)

  const handleOpenTab = (title) => {
    if (title === 'Все курсы') {
      setTab(false)
      setTitle('_courses')
    } else if (title === 'Календарь') {
      setTab(true)
      setTitle('_calendar')
    } else if (title === 'Архив') {
      setTab(true)
      setTitle('_archive')
    }
  }

  useEffect(() => {
    performanceData.forEach((e) => {
      api
        .getProgressCourse(token, e.id)
        .then((res) => {
          console.log(res)
          setCoursesProgress(res)
        })
        .catch((e) => {
          console.log(e)
        })
    })
  }, [])

  return (
    <>
      <div className="courses__wrapper">
        <div className="courses__container openedBlock__container">
          {tab && titleTag === '_calendar' && (
            <div className="courses__calendar">
              <Calendar></Calendar>
            </div>
          )}
          <div className="tab__wrap">
            <div
              className={
                'tab__btn' + (titleTag ? titleTag === '_courses' : 'true')
              }
              onClick={() => handleOpenTab('Все курсы')}
            >
              Мои курсы
            </div>
            {/* <div className={'tab__btn' + (titleTag ? titleTag === '_calendar' : 'false')} onClick={() => handleOpenTab('Календарь')}>Календарь</div> */}
          </div>
          {titleTag === '_courses' && (
            <OpenedBlock title={title} link={'/perfomance'}>
              <div className="courses__cards">
                {/* {cardType === 'task' ? (
                        performanceData.map((i, index) => (
                            i.is_blocked || i.is_blocked === null?
                            <LockedTaskCard
                            key={index} 
                            title={i.title} 
                            description={i.description} 
                            progress={i.attempts_left ? `${i.attempts_left} попытки` : undefined} 
                            totalTests={i.total_tests} 
                            deadline={i.days_left} 
                             />
                            :
                            <TaskCard key={index} 
                            title={i.title} 
                            description={i.description} 
                            progress={i.attempts_left ? `${i.attempts_left} попытки` : undefined} 
                            totalTests={i.total_tests} 
                            deadline={i.conference_id > 0 ? undefined : i.days_left} 
                            link={`/resource/${i.step_id}`} 
                            type={i.conference_id > 0 ? 'Видеоурок' : undefined}
                            confTime={
                                i.conference_id > 0
                                  ? getTime(i.start_time)
                                  : undefined
                              }
                              confDate={
                                i.conference_id > 0
                                  ? getDate(i.start_time)
                                  : undefined
                              }
                            />
                        )))
                        :                      */}
                {performanceData.map((i, index) => {
                  console.log(i)
                  return (
                    <>
                      <CourseCard
                        course={i}
                        key={index}
                        title={i.title}
                        image={i.image}
                        progress={i.completed_tests}
                        totalTests={i.total_tests}
                        average={`${i.avg}`}
                        link={
                          i.completed_tests === 'n'
                            ? `/performance/${i.id}`
                            : `course/${i.id}`
                        }
                        percent={i.progress_in_course}
                      />
                    </>
                  )
                })}
                {/* ))} */}
              </div>
            </OpenedBlock>
          )}
        </div>
      </div>
    </>
  )
}
export default Courses
